import React from "react";
import classes from "./LSEForm.module.css";

import pdfImage from "../../../../../../images/pdf.jpg";
import pdf from "../../../../../../files/LSEPamphlet.pdf";
const LSEForm = (props) => {
  return (
    <div className={classes.container}>
      <p>
        You can sponsor a child at LWAH School of Excellence (LSE) for US $444
        per month (for 9 months), covering his education, rehabilitation,
        transportation and other related services.
      </p>
      <p>
        If interested, you can download the PDF file and fill in the application
        form to give a child the gift of education!
      </p>
      <a href={pdf} target="_blank">
        <img src={pdfImage} alt="pdf" className={classes.link} />
      </a>
      <p><b>Bank Details:</b></p>
      <p><b>Lebanese Welfare Association for the Handicapped</b></p>
      <p><b>Account Number USD:</b> 0004-043931-210</p>
      <p><b>IBAN:</b> LB85 0094 0000 0000 0040 4393 1210</p>
      <p>
        <br />
      </p>
      <p><b>Account Number USD:</b> 0004-043931-202</p>
      <p><b>IBAN:</b> LB85 0094 0000 0000 0040 4393 1202</p>
      <p>
        <br />
      </p>
      <p><b>SWIFT:</b> LGBALBBE</p>
      <p>
        <br />
        <br />
      </p>
      <p>For further enquiries, please contact LWAH.</p>
      <p>Tel: +961 1 374100/1/2</p>
      <p>Fax: +961 1 374033</p>
      <p>E-mail: lwah@lwah.org.lb</p>
      <br/><br/><br/><br/><br/>
    </div>
  );
};
export default LSEForm;
